import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {H2} from "@irati/ui/src/Headings"
import Button from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"
import Validation from "@irati/utils/validation"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {hangPromise} from "@irati/utils/promise"
import Occasion from "@irati/types"
import Flex from "@irati/ui/src/Flex"

import IconPicker from "./IconPicker"
import {FlexRowSpaceBetween50Buttons, Input, H4} from "./styled"

interface Props extends InjectIntl {
  occasion?: Occasion,
  closeModal: () => void,
  upsertOccasion: (name: string, tag: string, icon: string, occasionId?: string) => Promise<void>
}

interface State {
  upserting?: Promise<void>,
  name: string,
  tag: string,
  icon: string
}

class EditForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      name: "",
      tag: "",
      icon: ""
    }
    // Defaulting state to props values (edit)
    const {occasion} = this.props
    if (occasion) {
      const {name, tag, icon} = occasion
      this.state = {name, tag, icon: icon.href}
    }
  }

  selectIcon = (icon: string) => {
    this.setState({icon})
  }

  handleSubmit = () => {
    const {name, tag, icon} = this.state
    const {occasion, upsertOccasion} = this.props
    let upserting = hangPromise()
    if (occasion) {
      upserting = upsertOccasion(name, tag, icon, occasion.uuid)
    } else {
      upserting = upsertOccasion(name, tag, icon)
    }
    this.setState({upserting})
  }

  render() {
    const {name, tag, icon, upserting} = this.state
    const {formatMessage, occasion} = this.props
    const {closeModal} = this.props
    const editOrCreateLabel = occasion ? "admin.occasions.create.buttons.saveEdit.label" : "admin.occasions.create.buttons.create.label"
    return (
      <Row>
        <Col md={6} mdOffset={3}>
          <Flex justifyContent="space-around" margin="15px 0">
            <H2><FormattedMessage id="admin.occasions.create.title" /></H2>
          </Flex>
          <Flex justifyContent="space-around">
            <H4><FormattedMessage id="admin.occasions.create.description" /></H4>
          </Flex>
        </Col>

        <Row>
          <Row>
            <Col md={6} mdOffset={3}>
              <Input
                label={formatMessage({id: "admin.occasions.create.fields.name.label"})}
                placeholder={formatMessage({id: "admin.occasions.create.fields.name.placeholder"})}
                name="name"
                value={name}
                onChange={(newName: string) => this.setState({name: newName})}
                validation={Validation.string("admin.helpers.codeSchema.validation.string")} />
            </Col>
          </Row>

          <Row>
            <Col md={6} mdOffset={3}>
              <Input
                label={formatMessage({id: "admin.occasions.create.fields.tag.label"})}
                placeholder={formatMessage({id: "admin.occasions.create.fields.tag.placeholder"})}
                hint={formatMessage({id: "admin.occasions.create.fields.tag.hint"})}
                name="tag"
                value={tag}
                margin="15px 0"
                onChange={(newTag: string) => this.setState({tag: newTag})}
                validation={Validation.string("admin.helpers.codeSchema.validation.string")} />
            </Col>
          </Row>
        </Row>

        <Col md={6} mdOffset={3}>
          <IconPicker
            selectIcon={(newIcon: string) => this.setState({icon: newIcon})}
            selectedIcon={icon} />

          <Loading load={upserting}>
            <FlexRowSpaceBetween50Buttons>
              <Button onClick={closeModal}>
                <FormattedMessage id="admin.occasions.create.buttons.cancel.label" />
              </Button>
              <ValidationButton primary onClick={this.handleSubmit}>
                <FormattedMessage id={editOrCreateLabel} />
              </ValidationButton>
            </FlexRowSpaceBetween50Buttons>
          </Loading>
        </Col>
      </Row>
    )
  }
}

export default injectIntl(EditForm)
